import React, { Component } from 'react'
import LoadingOverlay from '../loading/loading';
import { toast } from "react-toastify";
import authService from '../../services/authService';
import service from '../../services/service';

class ProfileForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: "",
            lastName: "",
            username: "",
            contact_number: "",
            password: "",
            invitationCode: "",
            loading: false,
            updateFields: {},
            updateAdminFields: {},
            balance: "",
            onHoldBalance: "",
            trialBalance: "",
            withdrawalAmount: "",
            commissionRate: "",
            addBalance: "",
            subtractBalance: "",
            bookings: "",
            isAdmin: sessionStorage.getItem('isAdmin') === 'true',
            showPassword: false,
        };
    }

    componentDidMount() {
        this.getUserDetailsByID();
    }

    getUserDetailsByID = async () => {
        this.setState({ loading: true });
        try {
            const isLoggedIn = sessionStorage.getItem('isLoggedIn') === 'true';
            if (!isLoggedIn) return;

            const isAdmin = sessionStorage.getItem('isAdmin') === 'true';
            const userId = isAdmin && this.props.userID ? this.props.userID : sessionStorage.getItem('userId');

            const [userDetail, walletDetails, currentHotelIndex] = await Promise.all([
                authService.getUserDetailsById(userId),
                service.view(`wallet/${userId}`),
                service.view(`hotel-sequence/user-bookings/${userId}`)
            ]);

            if (userDetail.success) {
                const { firstName, lastName, username, contact_number, password, invitationCode, commissionRate } = userDetail.user;
                this.setState({
                    firstName,
                    lastName,
                    username,
                    contact_number,
                    password,
                    invitationCode,
                    commissionRate
                });
            }

            if (walletDetails.success) {
                const { balance, onHoldBalance, trialBalance } = walletDetails.data;
                this.setState({
                    balance: balance.toFixed(2),
                    onHoldBalance: onHoldBalance.toFixed(2),
                    trialBalance: trialBalance.toFixed(2),
                    withdrawalAmount: "",
                    addBalance: "",
                    subtractBalance: ""
                });
            }

            if (currentHotelIndex.success) {
                this.setState({ bookings: currentHotelIndex.data });
            }

        } catch (error) {
            toast.error(error.message);
        } finally {
            this.setState({ loading: false });
        }
    }

    changeHandler = (e) => {
        const { name, value } = e.target;

        if (["balance", "onHoldBalance", "trialBalance", "withdrawalAmount", "addBalance", "subtractBalance"].includes(name)) {
            this.setState((prevState) => ({
                [name]: value,
                updateAdminFields: { ...prevState.updateAdminFields, [name]: value }
            }));
        } else {
            this.setState((prevState) => ({
                [name]: value,
                updateFields: { ...prevState.updateFields, [name]: value }
            }));
        }
    }

    submitHandler = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });
        try {
            const isAdmin = sessionStorage.getItem('isAdmin') === 'true';
            const userId = isAdmin && this.props.userID ? this.props.userID : sessionStorage.getItem('userId');

            const response = await authService.updateProfile(userId, this.state.updateFields);

            if (!response?.success) {
                toast.error(`${response?.message}: ${response?.displayMessage}`);
                return;
            }

            toast.success(`${response?.message}: ${response?.displayMessage}`);
        } catch (error) {
            toast.error(error.message);
        } finally {
            this.setState({ loading: false });
        }
    }

    submitAdminHandler = async (e) => {
        e.preventDefault();
        this.setState({ loading: true });

        try {
            const isAdmin = sessionStorage.getItem('isAdmin') === 'true';
            const userId = isAdmin && this.props.userID ? this.props.userID : sessionStorage.getItem('userId');

            const updateAdminFields = { ...this.state.updateAdminFields, userId };

            const response = await service.save(updateAdminFields, "wallet/update-wallet");

            if (!response?.success) {
                toast.error(response?.message);
                return;
            }

            toast.success(response?.message);
            this.setState({
                updateFields: {},
                updateAdminFields: {}
            });
            this.getUserDetailsByID();
        } catch (error) {
            toast.error(error.message);
        } finally {
            this.setState({ loading: false });
        }
    };

    togglePasswordVisibility = () => {
        this.setState((prevState) => ({
            showPassword: !prevState.showPassword,
        }));
    };

    render() {
        const { firstName, lastName, username, contact_number, invitationCode, password,
            isAdmin, loading, balance, onHoldBalance, trialBalance, withdrawalAmount, commissionRate,
            addBalance, subtractBalance, bookings, showPassword } = this.state;

        return (
            <>
                {loading && <LoadingOverlay />}
                <form onSubmit={this.submitHandler} className="contact-form">
                    <div className="row">
                        <div className="col-lg-4 col-12">
                            <div className="form-field">
                                <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>First Name</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={firstName}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="firstName"
                                    placeholder="e.g. John"
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="form-field">
                                <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>Last Name</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={lastName}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="lastName"
                                    placeholder="e.g. Doe"
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="form-field">
                                <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>Contact Number</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={contact_number}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (/^\d*$/.test(value)) { // Allows only digits (no decimals or negative signs)
                                            this.changeHandler(e);
                                        }
                                    }}
                                    type="text"
                                    name="contact_number"
                                    placeholder="e.g. 1 234 567 890"
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="form-field">
                                <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>Username</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={username}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="username"
                                    autoComplete="username"
                                    placeholder="e.g. john_doe99"
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="form-field">
                                <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>New Password</label>
                                <div className="input-group">
                                    <input
                                        style={{ color: "black" }}
                                        className="form-control"
                                        value={password}
                                        onChange={this.changeHandler}
                                        type={showPassword ? "text" : "password"}
                                        name="password"
                                        placeholder="e.g. ********"
                                        autoComplete="current-password"
                                    />
                                    <span
                                        className="input-group-text bg-white border-0 position-absolute top-50 end-0 translate-middle-y"
                                        style={{ cursor: "pointer" }}
                                        onClick={this.togglePasswordVisibility}
                                    >
                                        <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="form-field">
                                <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>Invitation Code</label>
                                <input
                                    style={{ color: 'black' }}
                                    value={invitationCode}
                                    onChange={this.changeHandler}
                                    type="text"
                                    name="invitationCode"
                                    placeholder="e.g. ABC123"
                                />
                            </div>
                        </div>
                        {isAdmin && (<>
                            <div className="col-lg-4 col-12">
                                <div className="form-field">
                                    <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>Commission (%)</label>
                                    <input
                                        style={{ color: 'black' }}
                                        value={commissionRate}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*$/.test(value)) { // Allows only digits (no decimals or negative signs)
                                                this.changeHandler(e);
                                            }
                                        }}
                                        type="text"
                                        name="commissionRate"
                                        placeholder="10%"
                                    />
                                </div>
                            </div>

                            <div className="col-lg-4 col-12">
                                <div className="form-field">
                                    <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>Current Bookings</label>
                                    <input
                                        style={{ color: 'black' }}
                                        value={bookings}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*$/.test(value)) { // Allows only digits (no decimals or negative signs)
                                                this.changeHandler(e);
                                            }
                                        }}
                                        type="text"
                                        name="bookings"
                                        placeholder="e.g. 0"
                                    />
                                </div>
                            </div>
                        </>)}
                        <div className="col-lg-12 col-12 text-end">
                            <div className="form-field">
                                <button type="submit" className="theme-btn" style={{ padding: '10px 40px', marginTop: '30px' }}>Update</button>
                            </div>
                        </div>
                    </div>
                </form>
                {/* Admin-Only Form */}
                {isAdmin && (
                    <>
                        <h2 style={{ fontSize: '26px', marginBottom: '26px' }}>Manage Balance</h2>
                        <div className="contact-form">
                            <form onSubmit={this.submitAdminHandler} className="contact-form">
                                <div className="row">
                                    <div className="col-lg-4 col-12">
                                        <div className="form-field">
                                            <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>Total Balance</label>
                                            <input
                                                style={{ color: 'black' }}
                                                value={balance}
                                                type="text"
                                                readOnly={true}
                                                disabled={true}
                                                name="balance"
                                                placeholder="100000"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-12">
                                        <div className="form-field">
                                            <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>On Hold Balance</label>
                                            <input
                                                style={{ color: 'black' }}
                                                value={onHoldBalance}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d{0,2}$/.test(value)) { // Allows only digits (no decimals or negative signs)
                                                        this.changeHandler(e);
                                                    }
                                                }}
                                                type="text"
                                                name="onHoldBalance"
                                                placeholder="100000"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-12">
                                        <div className="form-field">
                                            <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>Trial Balance</label>
                                            <input
                                                style={{ color: 'black' }}
                                                value={trialBalance}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d{0,2}$/.test(value)) { // Allows only digits (no decimals or negative signs)
                                                        this.changeHandler(e);
                                                    }
                                                }}
                                                type="text"
                                                name="trialBalance"
                                                placeholder="100000"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-12">
                                        <div className="form-field">
                                            <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>Withdrawal Amount</label>
                                            <input
                                                style={{ color: 'black' }}
                                                value={withdrawalAmount}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d{0,2}$/.test(value)) { // Allows only digits (no decimals or negative signs)
                                                        this.changeHandler(e);
                                                    }
                                                }}
                                                type="text"
                                                name="withdrawalAmount"
                                                placeholder="100000"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-12">
                                        <div className="form-field">
                                            <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>Add Balance</label>
                                            <input
                                                style={{ color: 'black' }}
                                                value={addBalance}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d{0,2}$/.test(value)) { // Allows only digits (no decimals or negative signs)
                                                        this.changeHandler(e);
                                                    }
                                                }}
                                                type="text"
                                                name="addBalance"
                                                placeholder="xxxxxxx"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-12">
                                        <div className="form-field">
                                            <label className="form-label" style={{ fontSize: '14px', fontWeight: 'bold', marginBottom: 0 }}>Subtract Balance</label>
                                            <input
                                                style={{ color: 'black' }}
                                                value={subtractBalance}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (/^\d*\.?\d{0,2}$/.test(value)) { // Allows only digits (no decimals or negative signs)
                                                        this.changeHandler(e);
                                                    }
                                                }}
                                                type="text"
                                                name="subtractBalance"
                                                placeholder="xxxxxxx"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 text-end">
                                        <button type="submit" className="theme-btn" style={{ padding: '10px 40px', marginTop: '30px' }}>Update</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </>
                )}
            </>
        )
    }
}
export default ProfileForm;